import { getLogger, type LayoutOverrideProps, useScrollToAnchor, useScrollToTop } from '@omnia/ui/src/lib'
import { RootLevelErrorBoundary } from '@omnia/ui/src/lib/cms/core-components/rootLevelErrorBoundary/RootLevelErrorBoundary'
import useNotificationObserver from '@omnia/ui/src/lib/hooks/useNotificationObserver'
import { NotificationListComponent } from '@vista-digital/occ-ui'
import { ErrorBoundary } from '@vista-digital/react-tools'
import type { ErrorInfo, FC } from 'react'
import { memo, Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { NotificationBannersList } from '@/common/components/notificationBannersList/NotificationBannersList'
import Popups from '@/common/components/popup/Popups'
import { Footer } from './footer/Footer'
import { Header } from './header/Header'
import { AbandonOrderModal } from '@/features/ticketing/components/abandonOrderModal/AbandonOrderModal'

export const Layout: FC<LayoutOverrideProps> = memo(({ rootLevelErrorBoundaryOverride }) => {
    const logRootLevelError = (error: Error, info: ErrorInfo) => {
        const loggerRoot = getLogger(['RootLevelErrorBoundary', error.name]).value
        loggerRoot.error(error.message, { stack: error.stack, componentStack: info.componentStack })
    }

    useScrollToAnchor()
    useScrollToTop()
    useNotificationObserver()

    const ErrorBoundaryElement = rootLevelErrorBoundaryOverride ?? RootLevelErrorBoundary

    return (
        <ErrorBoundary
            fallback={
                <Suspense>
                    <ErrorBoundaryElement />
                </Suspense>
            }
            onError={logRootLevelError}
        >
            <NotificationBannersList />
            <Header />
            <Popups />
            <main className="page-wrapper">
                <Outlet />
            </main>
            <NotificationListComponent />
            <AbandonOrderModal />
            <Footer />
        </ErrorBoundary>
    )
})
